module.exports = __webpack_public_path__ + "img/Good.b315e620.png";